/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    func, number, string, object,
} from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import TextFieldWrapper from '../Partials/TextFieldWrapper/TextFieldWrapper';

const styles = {
    error: {
        color: '#f44336',
    },
    textboxarea: {
        padding: '10px 0px',
        '& label': {
            fontSize: '1rem',
        },
    },
    widthFull: {
        width: '100%',
    },
};

class GiftMessageTextBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            giftMessage: '',
            authorName: '',
            errorMessage: '',
        };
        this.messageLen = 0;
    }

    componentDidMount() {
        this.initGiftMessage();
    }

    componentDidUpdate(prevProps) {
        const { savedGiftMessage } = this.props;
        if (prevProps.savedGiftMessage !== savedGiftMessage) this.initGiftMessage();
    }

    initGiftMessage = () => {
        let giftMessage = '';
        let authorName = '';

        const {
            savedGiftMessage, maxNoOfChar,
            handleChangeGiftMessageText,
            isInputFilled,
        } = this.props;

        if (savedGiftMessage?.length > 0 && savedGiftMessage !== 'No Card Message') {
            const testMatch = savedGiftMessage.match(/From:/);

            if (testMatch?.length > 0) {
                const intFromMessage = savedGiftMessage.lastIndexOf('From:');
                authorName = savedGiftMessage.substring((intFromMessage + 5));
                giftMessage = savedGiftMessage.substring(0, intFromMessage);
            } else {
                giftMessage = savedGiftMessage;
            }
        }

        giftMessage = giftMessage.trim();
        authorName = authorName.trim();

        const giftMessageAndAuthor = `${giftMessage} | ${authorName}`;
        this.messageLen = maxNoOfChar - giftMessage.length;

        handleChangeGiftMessageText({
            value: giftMessageAndAuthor,
            messageLen: this.messageLen,
        });

        isInputFilled('giftMessage', !(giftMessage && authorName));

        this.setState({
            giftMessage,
            authorName,
        });
    }

    handleBlur = () => {
        const { giftMessage, authorName } = this.state;
        const { isInputFilled } = this.props;
        let isFormNotValid = true;

        if (giftMessage && authorName) {
            isFormNotValid = false;
            this.setState({
                errorMessage: '',
            });
        } else {
            this.setState({
                errorMessage: 'Gift Message is required',
            });
        }

        isInputFilled('giftMessage', isFormNotValid);
    }

    getGiftMessageBox = () => {
        const { maxNoOfChar, classes, signatureMaxChars } = this.props;
        const { giftMessage, authorName, errorMessage } = this.state;

        return (
            <Grid className="wrapperGiftMessageForm" container>
                <Grid className={`${classes.textboxarea} ${classes.widthFull}`} item>
                    <TextFieldWrapper
                        textarea
                        required
                        setTextInputState={this.updateGiftMessage}
                        val={giftMessage}
                        label="Write your gift message here..."
                        name="giftMessage"
                        inputType="AlphaNumericGiftMessage"
                        isInputFilled={this.handleBlur}
                        max={maxNoOfChar}
                        rows={7}
                    />
                </Grid>
                <Grid className={`${classes.textboxarea} ${classes.widthFull}`} item>
                    <TextFieldWrapper
                        required
                        setTextInputState={this.updateGiftMessage}
                        val={authorName}
                        label="From"
                        name="authorName"
                        inputType="AlphaNumericGiftMessage"
                        isInputFilled={this.handleBlur}
                        max={signatureMaxChars || 20}
                    />
                </Grid>
                <Grid className={classes.widthFull} item>
                    {errorMessage && (
                        <Typography className={classes.error}>
                            {errorMessage}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        );
    }

    updateGiftMessage = (event) => {
        const {
            maxNoOfChar,
            handleChangeGiftMessageText,
            isInputFilled,
        } = this.props;

        const { giftMessage, authorName } = this.state;
        let updateGiftMessage = '';
        let updateAuthorName = '';

        let giftMessageAndAuthor = '';
        const elementName = event.target.name;
        const elementValue = event.target.value;

        if (elementName === 'giftMessage') {
            updateGiftMessage = elementValue;
            updateAuthorName = authorName;
            this.messageLen = maxNoOfChar - elementValue.length;
        } else if (elementName === 'authorName') {
            updateGiftMessage = giftMessage;
            updateAuthorName = elementValue;
        }

        giftMessageAndAuthor = `${updateGiftMessage} | ${updateAuthorName}`;

        handleChangeGiftMessageText({
            value: giftMessageAndAuthor,
            messageLen: this.messageLen,
        });

        const isNotValid = !(updateGiftMessage && updateAuthorName);

        isInputFilled('giftMessage', isNotValid);

        this.setState({
            [elementName]: elementValue,
        });
    }

    render() {
        return (
            <Grid>
                {this.getGiftMessageBox()}
            </Grid>
        );
    }
}

GiftMessageTextBox.propTypes = {
    handleChangeGiftMessageText: func.isRequired,
    isInputFilled: func.isRequired,
    maxNoOfChar: number.isRequired,
    savedGiftMessage: string,
    classes: object.isRequired,
    signatureMaxChars: number.isRequired,
};

GiftMessageTextBox.defaultProps = {
    savedGiftMessage: '',
};

export default withStyles(styles)(GiftMessageTextBox);
